export const calculatorDlsInput = ({
  requiredFields = [],
  filledFormData = {},
  roundToDecimal = 2,
}
) => {
  let temp = 0;
  requiredFields.forEach((field) => {
    let val = field.fieldId ? filledFormData[field.fieldId] : field.staticValue;
    if (!val) val = '0';
    const numericVal = Number.parseFloat(val.replace(/,/g, ''));
    switch (field.method) {
      case '+':
        if (!field.dynamicResult || field.dynamicResult === 'false') {
          temp += numericVal;
        }
        break;
      case '-':
        temp = Number.parseFloat(temp) - numericVal;
        break;
      case '/':
        if (numericVal !== 0) {
          temp = temp === 0 ? numericVal : temp / numericVal;
        }
        break;
      case '*':
        temp = temp === 0 ? 1 : temp;
        temp *= numericVal;
        break;
      case 'isPositive':
        temp = numericVal <= 0 ? 0 : 1;
        break;
      default:
        temp *= 1;
    }
  });

  return Number.parseFloat(temp.toFixed(roundToDecimal));

  // trim temp to 2 decimal places and do not round off and return float value
  // const multiplier = 10 ** roundToDecimal;
  // const result = Math.trunc(temp * multiplier) / multiplier;
  // return result;
};
